(() => {
  'use strict';

  const updateProductVariant = (form) => {
    const selector = form.querySelector('[data-variant-selector]');
    const choice = selector?.selectedOptions[0];
    if (!choice) return;
    const product = form.closest('[data-product-section]');
    const available = choice.dataset.available === 'true';
    const checkoutEnabled = form.dataset.checkoutEnabled === 'true';
    const button = form.querySelector('[data-add-to-cart]');
    const label = button?.querySelector('[data-add-label]');
    if (button) button.disabled = !available || !checkoutEnabled;
    if (label) label.textContent = !checkoutEnabled ? 'Checkout is being prepared' : available ? 'Add to cart' : 'Sold out';
    const availability = product?.querySelector('[data-availability]');
    if (availability) availability.textContent = !checkoutEnabled ? 'Private preview · Checkout opens after launch.' : available ? 'Available now' : 'This edition is currently unavailable.';
    const price = product?.querySelector('[data-product-price]');
    if (price) price.textContent = choice.dataset.price || '';
    const compare = product?.querySelector('[data-compare-price]');
    if (compare) {
      compare.textContent = choice.dataset.comparePrice || '';
      compare.hidden = !choice.dataset.comparePrice;
    }
    const quantity = form.querySelector('[name="quantity"]');
    if (quantity) {
      const min = Number(choice.dataset.quantityMin || 1);
      const step = Number(choice.dataset.quantityStep || 1);
      quantity.min = String(min);
      quantity.step = String(step);
      if (choice.dataset.quantityMax) quantity.max = choice.dataset.quantityMax;
      else quantity.removeAttribute('max');
      const max = quantity.max ? Number(quantity.max) : Infinity;
      const current = Number(quantity.value) || min;
      quantity.value = String(Math.min(max, Math.max(min, min + Math.round((current - min) / step) * step)));
      quantity.disabled = !available;
    }
    const image = product?.querySelector('[data-product-image]');
    if (image && choice.dataset.image) {
      image.src = choice.dataset.image;
      image.removeAttribute('srcset');
      image.alt = choice.dataset.imageAlt || image.alt;
    }
    const acceleratedCheckout = form.querySelector('[data-payment-container]');
    if (acceleratedCheckout) acceleratedCheckout.hidden = !available || !checkoutEnabled;
    if (!document.documentElement.classList.contains('shopify-design-mode')) {
      const nextUrl = new URL(window.location.href);
      nextUrl.searchParams.set('variant', choice.value);
      window.history.replaceState({}, '', nextUrl);
    }
  };

  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-feature-carousel]').forEach((carousel) => {
      if (carousel.dataset.rmbInitialized) return;
      carousel.dataset.rmbInitialized = 'true';
      const slides = [...carousel.querySelectorAll('[data-feature-slide]')];
      const dots = [...carousel.querySelectorAll('[data-feature-dot]')];
      let index = 0;
      const show = (next) => {
        index = (next + slides.length) % slides.length;
        slides.forEach((slide, i) => { slide.hidden = i !== index; });
        dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === index)));
        const status = carousel.querySelector('[data-feature-status]');
        if (status) status.textContent = `${index + 1} of ${slides.length}`;
      };
      carousel.querySelector('[data-feature-prev]')?.addEventListener('click', () => show(index - 1));
      carousel.querySelector('[data-feature-next]')?.addEventListener('click', () => show(index + 1));
      dots.forEach((dot, i) => dot.addEventListener('click', () => show(i)));
      carousel.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault(); show(index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
    });
    scope.querySelectorAll('[data-card-preview]').forEach((button) => {
      if (button.dataset.rmbInitialized) return;
      button.dataset.rmbInitialized = 'true';
      const audio = button.closest('.rmb-product-card-visual')?.querySelector('[data-card-audio]');
      if (!audio) return;
      const update = () => {
        button.setAttribute('aria-pressed', String(!audio.paused));
        button.querySelector('.rmb-preview-play').hidden = !audio.paused;
        button.querySelector('.rmb-preview-pause').hidden = audio.paused;
        button.setAttribute('aria-label', `${audio.paused ? 'Play' : 'Pause'} ${audio.getAttribute('aria-label')}`);
      };
      button.addEventListener('click', () => {
        if (audio.paused) audio.play().catch(() => {
          button.setAttribute('aria-label', 'Preview unavailable. Open the pack to listen.');
          update();
        });
        else audio.pause();
      });
      audio.addEventListener('play', update);
      audio.addEventListener('pause', update);
      audio.addEventListener('ended', update);
    });
    scope.querySelectorAll('[data-product-form]').forEach((form) => {
      if (form.dataset.rmbInitialized) return;
      form.dataset.rmbInitialized = 'true';
      form.querySelector('[data-variant-selector]')?.addEventListener('change', () => updateProductVariant(form));
      form.addEventListener('submit', (event) => {
        const selector = form.querySelector('[data-variant-selector]');
        const choice = selector?.selectedOptions[0];
        if (form.dataset.checkoutEnabled !== 'true' || (choice && choice.dataset.available !== 'true')) event.preventDefault();
      });
    });
    scope.querySelectorAll('[data-cart-form]').forEach((form) => {
      if (form.dataset.rmbInitialized) return;
      form.dataset.rmbInitialized = 'true';
      form.addEventListener('submit', (event) => {
        if (form.dataset.checkoutEnabled !== 'true' && event.submitter?.name === 'checkout') event.preventDefault();
      });
    });
    scope.querySelectorAll('[data-product-thumbnail]').forEach((thumbnail) => {
      if (thumbnail.dataset.rmbInitialized) return;
      thumbnail.dataset.rmbInitialized = 'true';
      thumbnail.addEventListener('click', () => {
        const product = thumbnail.closest('[data-product-section]');
        const image = product?.querySelector('[data-product-image]');
        if (!image) return;
        image.src = thumbnail.dataset.image;
        image.removeAttribute('srcset');
        image.alt = thumbnail.dataset.imageAlt || '';
        product.querySelectorAll('[data-product-thumbnail]').forEach((button) => button.setAttribute('aria-pressed', String(button === thumbnail)));
      });
    });
    scope.querySelectorAll('[data-collection-sort]').forEach((selector) => {
      if (selector.dataset.rmbInitialized) return;
      selector.dataset.rmbInitialized = 'true';
      selector.addEventListener('change', () => {
        const nextUrl = new URL(window.location.href);
        nextUrl.searchParams.set('sort_by', selector.value);
        nextUrl.searchParams.delete('page');
        window.location.assign(nextUrl.toString());
      });
    });
    scope.querySelectorAll('audio').forEach((audio) => {
      if (audio.dataset.rmbInitialized) return;
      audio.dataset.rmbInitialized = 'true';
      audio.addEventListener('play', () => document.querySelectorAll('audio').forEach((other) => { if (other !== audio) other.pause(); }));
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();

/* Quick add + quick view + marquee popup (drum-shop chrome) */
(() => {
  'use strict';
  const money = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
  const esc = (s) => String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

  let toastTimer;
  const toast = (msg) => {
    let el = document.querySelector('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { el.hidden = true; }, 2600);
  };

  const bumpCart = () => fetch('/cart.js').then((r) => r.json()).then((cart) => {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
      const link = el.closest('a');
      if (link) link.setAttribute('aria-label', 'Cart, ' + cart.item_count + ' items');
    });
  }).catch(() => {});

  const quickAdd = (variantId, title, btn) => {
    if (btn) btn.disabled = true;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
    })
      .then((r) => { if (!r.ok) throw new Error('unavailable'); return r.json(); })
      .then(() => bumpCart().then(() => toast('Added to cart' + (title ? ' — ' + title : ''))))
      .catch(() => toast('Could not add to cart'))
      .finally(() => { if (btn) btn.disabled = false; });
  };

  document.addEventListener('click', (e) => {
    const addBtn = e.target.closest('[data-quick-add]');
    if (addBtn) {
      e.preventDefault();
      quickAdd(addBtn.dataset.quickAdd, addBtn.dataset.quickTitle, addBtn);
      return;
    }
    const viewBtn = e.target.closest('[data-quick-view]');
    if (viewBtn) {
      e.preventDefault();
      openQuickView(viewBtn.dataset.quickView, viewBtn);
      return;
    }
    if (e.target.closest('[data-marquee-open]')) {
      const opener = document.querySelector('[data-welcome-open]');
      if (opener) opener.click();
      return;
    }
    if (e.target.closest('[data-qv-close]') || (e.target.matches && e.target.matches('[data-qv]'))) closeQuickView();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeQuickView(); });

  const qv = () => document.querySelector('[data-qv]');
  function openQuickView(handle, btn) {
    const modal = qv();
    if (!modal) return;
    if (btn) btn.disabled = true;
    fetch('/products/' + handle + '.js')
      .then((r) => { if (!r.ok) throw new Error('missing'); return r.json(); })
      .then((p) => {
        const img = modal.querySelector('[data-qv-img]');
        img.src = p.featured_image || '';
        img.alt = p.title || '';
        modal.querySelector('[data-qv-type]').textContent = p.type || 'Sound library';
        modal.querySelector('[data-qv-title]').textContent = p.title || '';
        const price = p.price === 0 ? 'Free' : money.format(p.price / 100);
        modal.querySelector('[data-qv-price]').textContent = price;
        const descEl = modal.querySelector('[data-qv-desc]');
        if (descEl) {
          const tmp = document.createElement('div');
          tmp.innerHTML = p.description || '';
          let text = (tmp.textContent || '').replace(/\s+/g, ' ').trim();
          if (text.length > 190) { text = text.slice(0, 190); const cut = text.lastIndexOf(' '); if (cut > 80) text = text.slice(0, cut); text += '\u2026'; }
          descEl.textContent = text;
          descEl.hidden = !text;
        }
        const link = modal.querySelector('[data-qv-link]');
        link.href = p.url;
        const add = modal.querySelector('[data-qv-add]');
        const vid = (p.variants && p.variants.length ? p.variants.find((v) => v.available) || p.variants[0] : null);
        add.dataset.quickAdd = vid ? vid.id : '';
        add.dataset.quickTitle = p.title || '';
        add.disabled = !vid || !vid.available;
        add.onclick = () => { if (add.dataset.quickAdd) quickAdd(add.dataset.quickAdd, p.title, add); };
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
        modal.querySelector('[data-qv-close]').focus();
      })
      .catch(() => toast('Quick view unavailable'))
      .finally(() => { if (btn) btn.disabled = false; });
  }
  function closeQuickView() {
    const modal = qv();
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.body.style.overflow = '';
  }
})();

/* RMB SEO block v2 (2026-10-28): structured data + homepage/social meta fallbacks.
   Additive only — injects tags the theme head does not render. Safe to remove wholesale. */
(() => {
  if (window.__rmbSeo) return; window.__rmbSeo = true;
  const head = document.head;
  const desc = 'Soul, lofi & R&B sample packs, drum kits and presets by Grammy-nominated producer RMB Justize — records with Wiz Khalifa, Nas & Larry June. Start free: Sampler 2026.';
  const heroImg = 'https://cdn.shopify.com/s/files/1/1040/4049/7521/files/rmb-hero-real.jpg?v=1792504826';
  const isHome = location.pathname === '/' || location.pathname === '';
  const og = (p) => { const el = head.querySelector('meta[property="' + p + '"]'); return el ? el.getAttribute('content') : null; };
  if (isHome && !head.querySelector('meta[name="description"]')) {
    const m = document.createElement('meta');
    m.setAttribute('name', 'description'); m.setAttribute('content', desc);
    head.appendChild(m);
  }
  if (isHome && document.title.trim() === 'RMB Justize') {
    document.title = 'RMB Justize — Soul Sample Packs, Drum Kits & Presets';
  }
  if (!og('og:image')) {
    const m = document.createElement('meta');
    m.setAttribute('property', 'og:image'); m.setAttribute('content', heroImg);
    head.appendChild(m);
  }
  if (!head.querySelector('meta[name="twitter:card"]')) {
    const tw = [['twitter:card', 'summary_large_image'],
                ['twitter:title', og('og:title') || document.title],
                ['twitter:description', (head.querySelector('meta[name="description"]') || {}).content || desc],
                ['twitter:image', og('og:image')]];
    tw.forEach(([n, v]) => { if (!v) return; const m = document.createElement('meta'); m.setAttribute('name', n); m.setAttribute('content', v); head.appendChild(m); });
  }
  const addSchema = (obj, key) => {
    if (document.querySelector('script[data-rmb-schema="' + key + '"]')) return;
    const s = document.createElement('script');
    s.type = 'application/ld+json'; s.setAttribute('data-rmb-schema', key);
    s.textContent = JSON.stringify(obj);
    head.appendChild(s);
  };
  addSchema({
    '@context': 'https://schema.org',
    '@graph': [
      { '@type': 'Organization',
        '@id': 'https://rmbjustize.com/#org',
        name: 'RMB Justize',
        url: 'https://rmbjustize.com/',
        logo: 'https://cdn.shopify.com/s/files/1/1040/4049/7521/files/exec-0a2838c8-0634-4112-a4b0-95424ee5141d.png',
        description: desc,
        sameAs: ['https://www.instagram.com/rmbjustize',
                 'https://open.spotify.com/artist/2xLhxXgR236ZtWjZOfa0Kd',
                 'https://music.apple.com/us/artist/rmb-justize/448367961',
                 'https://www.youtube.com/@rmbjustize',
                 'https://www.linkedin.com/in/rmbjustize'] },
      { '@type': 'WebSite',
        '@id': 'https://rmbjustize.com/#site',
        url: 'https://rmbjustize.com/',
        name: 'RMB Justize',
        publisher: { '@id': 'https://rmbjustize.com/#org' } }
    ]
  }, 'org');
  const h1 = (document.querySelector('h1') || {}).textContent;
  const pageName = h1 ? h1.trim().replace(/\s+/g, ' ') : null;
  const canon = (document.querySelector('link[rel="canonical"]') || {}).href || location.href;
  const crumbs = [{ '@type': 'ListItem', position: 1, name: 'Home', item: 'https://rmbjustize.com/' }];
  if (location.pathname.indexOf('/products/') === 0 && pageName) {
    crumbs.push({ '@type': 'ListItem', position: 2, name: 'All Sounds', item: 'https://rmbjustize.com/collections/all' });
    crumbs.push({ '@type': 'ListItem', position: 3, name: pageName, item: canon });
    addSchema({ '@context': 'https://schema.org', '@type': 'BreadcrumbList', itemListElement: crumbs }, 'crumbs');
  } else if (location.pathname.indexOf('/collections/') === 0 && pageName) {
    crumbs.push({ '@type': 'ListItem', position: 2, name: pageName, item: canon });
    addSchema({ '@context': 'https://schema.org', '@type': 'BreadcrumbList', itemListElement: crumbs }, 'crumbs');
  }
})();
